import { Stack } from "@mui/material";
import { ImageNoData, TextNoData } from "./component";

const NoRowsOverlay = () => {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center">
      <ImageNoData />
      <TextNoData>No Data</TextNoData>
    </Stack>
  );
};

export default NoRowsOverlay;
